// MUI
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

interface Props {
  label: string;
}

const CustomersListHeading = ({ label }: Props) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        height: '32px',
      }}
    >
      <Typography variant="subtitle1">{label}</Typography>
    </Box>
  );
};

export default CustomersListHeading;
